import BaseComponent from '@js/BaseComponent'
import hljs from 'highlight.js/lib/core'

// Core languages
import css from 'highlight.js/lib/languages/css'
import glsl from 'highlight.js/lib/languages/glsl'
import xml from 'highlight.js/lib/languages/xml'
import json from 'highlight.js/lib/languages/json'
import javascript from 'highlight.js/lib/languages/javascript'
import markdown from 'highlight.js/lib/languages/markdown'
import php from 'highlight.js/lib/languages/php'
import processing from 'highlight.js/lib/languages/processing'
import python from 'highlight.js/lib/languages/python'
import scss from 'highlight.js/lib/languages/scss'
import shell from 'highlight.js/lib/languages/shell'
import swift from 'highlight.js/lib/languages/swift'

// Language extensions
import curl from 'highlightjs-curl'

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('css', css)
hljs.registerLanguage('curl', curl)
hljs.registerLanguage('glsl', glsl)
hljs.registerLanguage('html', xml) // rename
hljs.registerLanguage('json', json)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('markdown', markdown)
hljs.registerLanguage('php', php)
hljs.registerLanguage('processing', processing)
hljs.registerLanguage('python', python)
hljs.registerLanguage('scss', scss)
hljs.registerLanguage('shell', shell)
hljs.registerLanguage('swift', swift)

/**
 * Enables syntax highlighting of code blocks using highlight.js.
 *
 * Highlighting will be added to all elements with `class="codeblock"`. Elements
 * can be disabled using the class `.no-hljs`.
 *
 * The language is set using a class formatted as `language-[language_name]`.
 * Languages must be one from the registered list above.
 *
 * @extends BaseComponent
 */
class Codeblock extends BaseComponent {
    constructor(element) {
        super(element)

        const codeElem = element.querySelector('code')

        hljs.highlightElement(codeElem)
    }
}

Codeblock.create('.codeblock:not(.no-hljs)')
